/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import {
  Box,
  Grid,
  Link,
  Section,
  SemiTitle,
  Text,
  Title,
} from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

export default function BrandDistributors({ brand, ...rest }) {
  if (!hasContent(brand)) return null;
  return (
    <Section {...rest}>
      <Title sx={{ marginBottom: 3 }}>
        <Trans comment="The title of the Brand distributors - either a list of countries or a list of importers per country.">
          Distribution
        </Trans>
      </Title>
      <Grid columns={[2, 3, 4]} gap={2}>
        {brand.distributors.byCountry.map(({ country, distributors }) => (
          <Box>
            <SemiTitle key={country} sx={{ marginTop: 0 }}>
              {country}
            </SemiTitle>
            {distributors.map(({ name, url }) => (
              <Text key={name} sx={{ marginBottom: 2 }}>
                <Link href={url}>{name}</Link>
              </Text>
            ))}
          </Box>
        ))}
      </Grid>
    </Section>
  );
}
BrandDistributors.hasContent = hasContent;

function hasContent(brand) {
  if (!brand) return false;
  const byCountry = brand.distributors?.byCountry;
  if (byCountry?.length && byCountry[0]?.country) return true;
}

export const fragment = graphql`
  fragment bb_BrandDistributors on Bottlebooks_AbstractBrand {
    distributors(filter: { country: { ne: null } }) {
      byCountry: group(
        field: country
        sort: { fields: fieldValue, order: ASC }
      ) {
        country: fieldValue
        # The filter removes empty distributors from the country, while still grouping by country.
        distributors: nodes(filter: { name: { nin: [null, ""] } }) {
          name
          url
        }
      }
    }
  }
`;
